interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, totalPages: number): number[] {
  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let index = start; index <= end; index += 1) {
    pages.push(index);
  }
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <div className="flex flex-wrap items-center justify-center gap-1.5">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={[
            "h-9 w-9 cursor-pointer rounded-md border font-label text-xs transition-colors",
            item === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600",
          ].join(" ")}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex cursor-pointer items-center gap-1 rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}